import React, { useEffect } from 'react';
import { useTemplatesData } from '../../../../hooks/useTemplatesData';
import { usePageNavigate } from '../../../../hooks/usePageNavigate';
import { useValidateAndSet } from './useValidateAndSet';
import { BlocksModalLayout } from './BlocksModalLayout/BlocksModalLayout';
import { useModalState } from './useBlocksNamespaceModalState';

export const BlocksModal = ({ dataHook, closeModal }: any) => {
  const { currentTemplate: template } = useTemplatesData();
  const { openBlocksTemplateFlow } = usePageNavigate();
  const state = useModalState();
  const { validateAppName, validateAppNamespace, fetchSuggestions } =
    useValidateAndSet(state);

  useEffect(() => {
    void fetchSuggestions(template.title);
  }, []);

  useEffect(() => {
    if (
      state.isValidated ||
      state.name === undefined ||
      !state.isSuggestionsFetched
    ) {
      return;
    }
    const timeoutId = setTimeout(() => validateAppName(state.name), 500);
    return () => clearTimeout(timeoutId);
  }, [state.name]);

  useEffect(() => {
    if (
      !state.isSuggestionsFetched ||
      !state.namespacePrefixes?.[state.selectedNamespacePrefixType]
    ) {
      return;
    }
    const timeoutId = setTimeout(
      () =>
        validateAppNamespace(
          `${state.namespacePrefixes[state.selectedNamespacePrefixType]}/${
            state.namespace
          }`,
        ),
      500,
    );
    return () => clearTimeout(timeoutId);
  }, [state.namespace, state.selectedNamespacePrefixType]);

  const submit = async () => {
    openBlocksTemplateFlow({
      templateId: template.id,
      templateName: state.name,
      namespace: state.namespace,
      namespaceType: state.selectedNamespacePrefixType,
    });
    closeModal();
  };

  return (
    <BlocksModalLayout
      {...{
        dataHook,
        closeModal,
        submit,
        validateAppNamespace,
        ...state,
      }}
    />
  );
};
